// extracted by mini-css-extract-plugin
module.exports = {"c1pyjklk":"c1pyjklk","bounce-c1pyjklk":"bounce-c1pyjklk"};